export default "__VITE_ASSET__0b987156__"